import './consumption-history.scss'
import React, {useEffect, useState} from 'react'
import DataGrid, {
    Column,
    FilterRow,
    Format,
    HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Sorting,
    Summary,
    TotalItem,
} from 'devextreme-react/data-grid'
import LoadPanel from 'devextreme-react/load-panel'
import notify from 'devextreme/ui/notify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faClockRotateLeft} from '@fortawesome/free-solid-svg-icons'
import SelectPeriod from '../../components/select-period/select-period'
import {useAuth} from '../../contexts/auth'
import {usePeriod} from '../../contexts/period'
import {getConsumptionHistory} from '../../api/dogovor'
import {dogHasParameterMenu, verifyAccess} from '../../utils/admin.utils'
import {getHomeRoute} from '../../utils/navigation.utils'
import {useHistory} from 'react-router-dom'
import AccessDenied from '../../components/access-denied/access-denied'
import ZagolovokFromMenu from '../../components/zagolovok/zagolovok'

export default function ConsumptionHistoryPage() {
    const history = useHistory()
    const {selectedDog, dogovors} = useAuth()
    const {periodStart, periodEnd} = usePeriod()
    const [visiblePage, setVisiblePage] = useState(true)
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dogHasParameterMenu(selectedDog, '0') || !verifyAccess([2], selectedDog)) {
            setVisiblePage(false)
            history.replace(getHomeRoute(dogovors, selectedDog))
            return
        }
        setVisiblePage(true)
    }, [selectedDog, dogovors, history])

    useEffect(() => {
        if (!visiblePage || !selectedDog?.kodDog || periodStart == null || periodEnd == null) return
        ;(async () => {
            setLoading(true)
            const res = await getConsumptionHistory(selectedDog.kodDog, periodStart, periodEnd)
            if (res.isOk) setRows(res.data?.rows || [])
            else {
                notify(res.message, 'error', 5000)
                setRows([])
            }
            setLoading(false)
        })()
    }, [visiblePage, selectedDog?.kodDog, periodStart, periodEnd])

    if (!visiblePage) return <AccessDenied/>

    return (
        <div className="content-block dx-card responsive-paddings consumption-history">
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faClockRotateLeft}/>
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            <div className="row mt20 mb20 big-input" style={{alignItems: 'baseline'}}>
                <SelectPeriod mode={'multiple'}/>
            </div>
            <div id="consumption-history-grid">
                <LoadPanel visible={loading} position={{of: '#consumption-history-grid'}}/>
                <DataGrid
                    dataSource={rows}
                    noDataText="Нет данных за указанный период"
                    keyExpr="key"
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    wordWrapEnabled={true}
                    width="100%"
                    columnAutoWidth={true}
                >
                    <Scrolling columnRenderingMode="virtual"/>
                    <Paging defaultPageSize={12}/>
                    <Pager
                        visible={true}
                        allowedPageSizes={[5, 12, 20, 'all']}
                        displayMode="full"
                        showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true}
                    />
                    <Sorting mode="multiple"/>
                    <FilterRow visible={true}/>
                    <HeaderFilter visible={true}/>
                    <Column dataField="ymKey" caption="Отчетный период" dataType="string" width={140}/>
                    <Column dataField="voltage" caption="Уровень напряжения" dataType="string" width={140}/>
                    <Column dataField="energy" caption="Потребленная электроэнергия, кВтч" dataType="number">
                        <Format type="fixedPoint" precision={2}/>
                    </Column>
                    <Column dataField="powerFact" caption="Мощность фактическая, кВт" dataType="number">
                        <Format type="fixedPoint" precision={0}/>
                    </Column>
                    <Column dataField="powerNet" caption="Сетевая мощность, кВт" dataType="number">
                        <Format type="fixedPoint" precision={0}/>
                    </Column>
                    <Summary>
                        <TotalItem column="ymKey" displayFormat="Итого"/>
                        <TotalItem column="energy" summaryType="sum" valueFormat={{type: 'fixedPoint', precision: 2}} displayFormat="{0}"/>
                        <TotalItem column="powerFact" summaryType="sum" valueFormat={{type: 'fixedPoint', precision: 0}} displayFormat="{0}"/>
                        <TotalItem column="powerNet" summaryType="sum" valueFormat={{type: 'fixedPoint', precision: 0}} displayFormat="{0}"/>
                    </Summary>
                </DataGrid>
            </div>
        </div>
    )
}
